export const EMAIL = [
    {
        id: '1',
        value: 'confirmed-with-errors',
        label: 'Подтвержденные проблемные',
        children: [
            {
                id: '2',
                value: 'invalid',
                label: 'Адрес не существует или введён неправильно',
            },
            {
                id: '3',
                value: 'permanent_unavailable',
                label: 'Постоянная недоступность адреса',
            },
            {
                id: '4',
                value: 'temporary_unavailable',
                label: 'Временная недоступность адреса',
            },
            {
                id: '5',
                value: 'blocked',
                label: 'Блокировка адреса администратором (блок от юнисендер)',
            },
            {
                id: '6',
                value: 'unsubscribed',
                label: 'Пользователь отписался',
            },
            {
                id: '7',
                value: 'complained',
                label: 'Пользователь пожаловался на спам',
            },
        ],
    },
    {
        id: '8',
        value: 'non-confirmed-with-errors',
        label: 'Неподтвержденные проблемные',
        children: [
            {
                id: '9',
                value: 'invalid',
                label: 'Адрес не существует или введён неправильно',
            },
            {
                id: '10',
                value: 'permanent_unavailable',
                label: 'Постоянная недоступность адреса',
            },
            {
                id: '11',
                value: 'temporary_unavailable',
                label: 'Временная недоступность адреса',
            },
            {
                id: '12',
                value: 'blocked',
                label: 'Блокировка адреса администратором (блок от юнисендер)',
            },
            {
                id: '13',
                value: 'unsubscribed',
                label: 'Пользователь отписался',
            },
            {
                id: '14',
                value: 'complained',
                label: 'Пользователь пожаловался на спам',
            },
        ],
    },
    {
        id: '15',
        value: 'confirmed',
        label: 'Подтвержденные непроблемные',
    },
    {
        id: '16',
        value: 'non-confirmed',
        label: 'Неподтвержденные непроблемные',
    },
];

export const TARIFF = [
    {
        id: 'new',
        value: 'new',
        label: 'Новые',
        children: [
            {
                id: '7',
                value: '7',
                label: 'Бесплатный',
            },
            {
                id: '8',
                value: '8',
                label: 'Старт',
            },
            {
                id: '9',
                value: '9',
                label: 'Старт+',
            },
            {
                id: '10',
                value: '10',
                label: 'Профессионал',
            },
            {
                id: '11',
                value: '11',
                label: 'Профессионал+',
            },
            {
                id: '12',
                value: '12',
                label: 'Команда',
            },
            {
                id: '13',
                value: '13',
                label: 'Бизнес',
            },
            {
                id: '14',
                value: '14',
                label: 'Компания',
            },

        ],
    },
    {
        id: 'archive',
        value: 'archive',
        label: 'Архивные',
        children: [
            {
                id: '1',
                value: '1',
                label: 'Бесплатный (арх.)',
            },
            {
                id: '2',
                value: '2',
                label: 'Профессионал (арх.)',
            },
            {
                id: '3',
                value: '3',
                label: 'Команда (арх.)',
            },
            {
                id: '4',
                value: '4',
                label: 'Компания (арх.)',
            },
        ],
    },
];

export const RECURRING = [
    {
        value: 'true',
        label: 'Включен',
    },
    {
        value: 'false',
        label: 'Не включен',
    },
];

export const MAILING = [
    {
        value: 'true',
        label: 'Есть',
    },
    {
        value: 'false',
        label: 'Нет',
    },
];

export const COUNT_MONITORS = [
    {
        value: '1-10',
        label: '1-10',
    },
    {
        value: '11-25',
        label: '11-25',
    },
    {
        value: '26-50',
        label: '26-50',
    },
    {
        value: '51-100',
        label: '51-100',
    },
    {
        value: '101-250',
        label: '101-250',
    },
    {
        value: '251-500',
        label: '251-500',
    },
    {
        value: '501-1000',
        label: '501-1000',
    },
];

export const COUNT_INCIDENT = [
    {
        value: '1-10',
        label: '1-10',
    },
    {
        value: '11-25',
        label: '11-25',
    },
    {
        value: '26-50',
        label: '26-50',
    },
    {
        value: '51-100',
        label: '51-100',
    },
    {
        value: '101-250',
        label: '101-250',
    },
    {
        value: '251-500',
        label: '251-500',
    },
    {
        value: '501-1000',
        label: '501-1000',
    },
];